export async function dataURItoBlob(dataURI: string) {
  const byteString = atob(dataURI.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.codePointAt(i);
  }
  return new Blob([ab], { type: "image/png" });
}

/**
 * Converte data URI (ex.: PDF em base64) em Object URL para uso em <a>/<iframe>.
 * Se não for data URI do mime informado, devolve a URL original.
 */
export function dataUriToObjectUrl(url?: string | null, mimePrefix = "data:application/pdf"): string {
  if (!url || !url.startsWith(mimePrefix)) return url ?? "";

  try {
    const [meta, b64] = url.split(",");
    if (!b64) return url;

    const mimeMatch = meta.match(/^data:([^;]+)/);
    const mimeType = mimeMatch?.[1] ?? "application/pdf";
    const bytes = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
    const blob = new Blob([bytes], { type: mimeType });
    return URL.createObjectURL(blob);
  } catch (e) {
    console.warn("Erro ao converter data URI para blob URL", e);
    return url;
  }
}

export async function downloadBlob(blob: Blob) {
  const url = globalThis.window.URL.createObjectURL(blob);
  const a: HTMLAnchorElement = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  a.href = url;
  a.target = "_blank";
  a.click();
  a.remove();
  globalThis.window.URL.revokeObjectURL(url);
}

export async function downloadUrl(url: string) {
  const a: HTMLAnchorElement = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  a.href = url;
  a.target = "_blank";
  a.click();
  a.remove();
}

export function downloadUrlWithName(url: string, fileName: string) {
  const a: HTMLAnchorElement = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  a.href = url;
  a.download = fileName;
  a.click();
  a.remove();
}

export async function downloadBlobWithName(blob: Blob, fileName: string) {
  const url = globalThis.window.URL.createObjectURL(blob);
  const a: HTMLAnchorElement = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  a.href = url;
  a.download = fileName;
  a.click();
  a.remove();
  globalThis.window.URL.revokeObjectURL(url);
}

export function blobToBase64(blob) {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
}
